/**
 * Màu + nhãn cho mức xếp loại metric/category trả từ BE (PsiParser).
 * good = xanh, average = vàng, poor = đỏ, na = xám.
 */
export const RATING_COLOR = {
	good: '#52c41a',
	average: '#faad14',
	poor: '#f5222d',
	na: '#9ca3af',
};

export const RATING_LABEL = {
	good: 'Tốt',
	average: 'Cần cải thiện',
	poor: 'Kém',
	na: 'Không có dữ liệu',
};

/** Định dạng thời gian ms → "1,2 s" hoặc "850 ms". */
export const fmtMs = (ms) => {
	if (ms === null || ms === undefined) return '—';
	if (ms >= 1000) return (ms / 1000).toFixed(1).replace('.', ',') + ' s';
	return Math.round(ms) + ' ms';
};

/** Định dạng CLS (không đơn vị). */
export const fmtCls = (v) => (v === null || v === undefined ? '—' : String(v).replace('.', ','));
